import {
  formatReceiptAmount,
  formatReceiptPln,
  formatReceiptStamp,
  type WypłataReceiptData,
} from "./wyplataReceipt.js";

export function WyplataReceiptCard({
  data,
  animated = false,
}: {
  data: WypłataReceiptData;
  /** Staggered line fade-in used during a fresh print. */
  animated?: boolean;
}) {
  const anim = animated ? "" : " is-static";
  return (
    <article className="wyplata-receipt">
      <header className="wyplata-receipt__brand">zioło.eu</header>
      <p className="wyplata-receipt__hint">
        Kupon z wypłaty butelkomatu. Ranking zostaje, sklep i portfel startują od zera. Żetony kasyna —
        raz na dobę.
      </p>
      <div className="wyplata-receipt__total">{formatReceiptPln(data.runGrosze)}</div>
      <div className="wyplata-receipt__barcode" aria-hidden="true">
        {Array.from({ length: 48 }, (_, i) => {
          const dig = Number(data.barcode[i % data.barcode.length] ?? "5");
          const wide = dig % 3 === 0;
          return <span key={i} className={wide ? "is-wide" : undefined} />;
        })}
      </div>
      <p className="wyplata-receipt__code">{data.barcode}</p>
      <ul className={`wyplata-receipt__lines${anim}`}>
        {data.lines.map((line) => (
          <li key={line.label}>
            <span>
              {line.count}x {line.label}
            </span>
            <span>{formatReceiptAmount(line.grosze)}</span>
          </li>
        ))}
      </ul>
      <div className={`wyplata-receipt__sum${anim}`}>
        <span>{data.returnedBottles}</span>
        <span>{formatReceiptAmount(data.runGrosze)}</span>
      </div>
      <p className={`wyplata-receipt__valid${anim}`}>Kupon ważny 90 dni</p>
      <p className={`wyplata-receipt__bonus${anim}`}>
        Bonus kaucji +{data.bonusPct}% → {data.nextMult.toFixed(2).replace(".", ",")}×
      </p>
      {data.chipsGranted > 0 ? (
        <p className={`wyplata-receipt__chips${anim}`}>
          Żetony kasyna +
          {data.chipsGranted >= 1_000_000 && data.chipsGranted % 1_000_000 === 0
            ? `${data.chipsGranted / 1_000_000} mln`
            : data.chipsGranted.toLocaleString("pl-PL")}
        </p>
      ) : (
        <p className={`wyplata-receipt__chips${anim}`}>Bez żetonów — limit dobowy</p>
      )}
      <footer className={`wyplata-receipt__meta${anim}`}>
        <span>zioło Butelkomat RVM</span>
        <span>{data.txnId}</span>
        <span>{formatReceiptStamp(data.printedAt)}</span>
        <span>Wypłata nr {data.prestigeCountAfter}</span>
      </footer>
    </article>
  );
}
